import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { portoutColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPortout } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "msisdn",
  "status",
  "port_status",
  "account_number",
  "account_password",
  "effective_date",
  "expiration_date",
  "created_at",
  "last_updated",
];

const PortoutBatch = () => (
  <BatchDetail
    title="Portout"
    apiGet={__getPortout}
    client={CLIENTS.it}
    columnsFactory={portoutColumns}
    copyKeys={COPY_KEYS}
    exportAction="portout"
    retryOperation="portout"
    showTerminate
    getRowPath={(row) => `/it/portout/${row.id}`}
  />
);

export default PortoutBatch;
